import type { FunnelStage } from '../../identityxp/framework';

type Props = {
  stages: FunnelStage[];
  funnel: string;
  title?: string;
};

export function IdentityFunnelChart({ stages, funnel, title }: Props) {
  const funnelStages = stages.filter((s) => s.funnel === funnel).sort((a, b) => a.order - b.order);
  const maxOrder = funnelStages.length;

  return (
    <div>
      {title && <h4 className="mb-3 text-sm font-semibold text-slate-700 dark:text-slate-300">{title}</h4>}
      <div className="space-y-2">
        {funnelStages.map((s, i) => {
          const widthPct = Math.round(((maxOrder - i) / maxOrder) * 100);
          return (
            <div key={s.stage} className="flex items-center gap-3">
              <span className="w-28 shrink-0 text-xs text-slate-600 dark:text-slate-400">{s.stage}</span>
              <div className="h-6 flex-1 overflow-hidden rounded bg-slate-100 dark:bg-slate-800">
                <div
                  className="flex h-full items-center rounded bg-brand-500/80 px-2 text-xs font-medium text-white transition-all duration-300"
                  style={{ width: `${widthPct}%` }}
                >
                  {widthPct}%
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
